module.exports = __webpack_public_path__ + "static/media/PHOTO_MIGUEL.26a0ca7c.png";